export const PERMISSION_CATEGORIES = [
  "partners",
  "templates",
  "tasks",
  "objectOverviews",
  "forms",
  "submissions",
  "commissionPlans",
  "commissionStatements",
  "assets",
  "aiAgent",
  "notifications",
  "announcements",
  "websiteVisitors",
  "team",
  "billing",
  "internalSso",
  "portal",
  "tiers",
  "integrations",
  "crmCopilot",
];

export const isCrmUser = (permissions: PrismaJson.TeamUserRolePermissions) => {
  return permissions?.isCrmUser === true;
};

/**
 * Check if a user has the isOwnPartnersOnly permission
 * @param user - The user to check
 * @returns True if the user has the isOwnPartnersOnly permission, false otherwise
 */
export const isOwnPartnersOnly = (user: {
  teamUserRole: { permissions: { isOwnPartnersOnly?: boolean } | null } | null;
}) => {
  return user.teamUserRole?.permissions?.isOwnPartnersOnly === true;
};

/**
 * Check if a user has a permission
 * @param permissions - The permissions of the user
 * @param permission - The permission to check
 * @returns True if the user has the permission, false otherwise
 */
export const hasPermission = (
  permissions: PrismaJson.TeamUserRolePermissions,
  permission: keyof PrismaJson.TeamUserRolePermissions
) => {
  if (permissions?.["has_all_permissions"] === true) return true;
  return !!permissions[permission];
};

/**
 * Check if a partner is accessible to a user
 */
export const aclPartnerAccessible = (props: {
  user: { teamUserRole: { permissions: { isOwnPartnersOnly?: boolean } | null } | null; id: string };
  partner: { ownerUserId: string | null };
}) => {
  const { user, partner } = props;
  if (!user.teamUserRole?.permissions?.isOwnPartnersOnly) return true;
  return user.teamUserRole.permissions.isOwnPartnersOnly && partner.ownerUserId === user.id;
};
